module.exports = __webpack_public_path__ + "img/marchenkov_500.362f39ab.jpg";